module.exports = __webpack_public_path__ + "static/media/group-lessons-icon.64239881.svg";